import { useEffect, useState } from 'react';
import { useForm, Controller } from 'react-hook-form';
import { classNames } from 'primereact/utils';
import { InputText } from 'primereact/inputtext';
import { Button } from 'primereact/button';
import { Dialog } from 'primereact/dialog';

// props:
// - visible
// - label
// - onHide
// - onLabelSaved
function LabelEditDialog(props) {

  // #region vars and consts

  const [isNew, setIsNew] = useState(false);
  const defaultValues = {
    description: ''
  };
  const {
    control,
    formState: { errors },
    handleSubmit,
    reset
  } = useForm({ defaultValues });

  //#endregion

  // #region methods

  const resetForm = () => {
    reset(defaultValues);    
  }

  const createLabel = (description) => {
    fetch(`${process.env.REACT_APP_API_URL}/airportService/v1/label/create`, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ description }),
    }).then(response => response.json()).then(data => {
      if (data.responseCode === 'OK') {
        console.log("LabelEditDialog: createLabel: success");
        props.onLabelSaved();
        reset();
      } else {
        console.log("LabelEditDialog: createLabel: error");
      }
    });
  };

  const updateLabel = (
    labelId,
    description) => {
    fetch(`${process.env.REACT_APP_API_URL}/airportService/v1/label/update`, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({
        labelId,
        description
      }),
    }).then(response => response.json()).then(data => {
      if (data.responseCode === 'OK') {
        console.log("LabelEditDialog: updateLabel: success");
        props.onLabelSaved();
        reset();
      } else {
        console.log("LabelEditDialog: updateLabel: error");
      }
    });
  };

  const getFormErrorMessage = (name) => {
    return errors[name] && (
      <small className="p-error">
        {errors[name].message}
      </small>
    )
  };

  // #endregion

  // #region events

  const onDialogHide = () => {
    if (props.onHide) props.onHide();
  };

  const onFormSubmit = (data) => {
    if (isNew) {
      createLabel(data.description);
    } else {
      updateLabel(props.label.labelId, data.description);
    }

  };

  // #endregion

  // #region templates

  const formTemplate = (
    <>
      <form
        onSubmit={handleSubmit(onFormSubmit)}
        className="p-fluid">
        <div className='pt-5'>
          <span className="p-float-label">
            <Controller
              name="description"
              control={control}
              rules={{ required: 'La descripción es requerida.' }}
              render={({ field, fieldState }) => (
                <InputText
                  id={field.description}
                  {...field}
                  autoFocus
                  className={classNames({ 'p-invalid': fieldState.invalid })} />
              )} />
            <label
              htmlFor="description"
              className={classNames({ 'p-error': errors.description })}>
              Descripción*
            </label>
          </span>
          {getFormErrorMessage('description')}
        </div>
        <Button
          type="submit"
          label="Guardar"
          className="p-button-raised p-button-sm mt-4" />
      </form>
    </>
  );

  const dialogTemplate = (
    <>
      <Dialog
        header=""
        visible={props.visible}
        onHide={onDialogHide}
        breakpoints={{ '960px': '75vw' }}
        style={{ width: '50vw' }}>
        <h1>Etiqueta</h1>
        {formTemplate}
      </Dialog>
    </>
  );

  // #endregion

  useEffect(() => {
    resetForm();
    setIsNew(props.label === null);
    if (props.label) {
      setIsNew(false);
      reset(props.label);       
    } else {
      setIsNew(true);
    }
  }, [props.visible, props.label]);

  return (
    <>
      <article>
        {dialogTemplate}
      </article>
    </>
  );
}

export default LabelEditDialog;